<template>
  <div>
    <!-- 头部 -->
    <top></top>
    <div class="main">
      <navMenu :active="active"></navMenu>
      <div
          class="content"
          v-loading.fullscreen.lock="loading"
      >
<!--        <div class="go-back" @click="goBack">返回</div>-->
<!--        <div class="btn_box">-->

          <!-- <div class="main-title">活动通知</div> -->
          <!-- <div class="search_box"><el-button size="medium" class="search" @click="changeContact('add','')"  type="primary">添加联系人</el-button></div> -->
<!--        </div>-->
        <el-form :inline="true" :model="formInline" label-position="top" class="demo-form-inline">
          <el-row :gutter="24" class="searchBox">
            <el-col :xl="6" :lg="5" :md="12" :sm="24" :xs="24">
              <el-form-item label="活动标题">
                <input class="searchInput" v-model="formInline.message_title" type="text" placeholder="请输入">
              </el-form-item>
            </el-col>
            <el-col :xl="6" :lg="9" :md="12" :sm="24" :xs="24">
              <el-form-item label="" class="searchFooter">
                <button class="btn search-btn" @click="getList">查询</button>
                <button class="btn" @click="reset">重置</button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div class="invitate-wrap">
          <!-- 列表 -->
          <div class="invitation-table">
            <el-table
                :data="tableData"
                style="width: 100%"
                :cell-style="{textAlign: 'center'}"
                :header-cell-style="{background:'#EDF1F7',color: '#333', textAlign: 'center'}"
            >
              <el-table-column
                  prop="message_title"
                  label="标题"
              >
                <template v-slot="scope">
                  <el-button
                      type="text"
                      @click="seeDetail(scope.row)">{{scope.row.message_title}}
                  </el-button>
                </template>
              </el-table-column>
              <el-table-column
                  prop="create_time"
                  label="发表时间">
              </el-table-column>
<!--              <el-table-column-->
<!--                  prop="desc"-->
<!--                  label="更新时间">-->
<!--              </el-table-column>-->
              <el-table-column
                  prop="is_see"
                  label="状态">
                <template v-slot="scope">
                  <span class="status sicon1" v-if="scope.row.is_see==1">已读</span>
                  <span class="status sicon2" v-if="scope.row.is_see==0">未读</span>
                </template>
              </el-table-column>
              <el-table-column
                  fixed="right"
                  label="操作"
                  width="180">
                <template v-slot="scope">
                  <el-button
                      @click.native.prevent="seeDetail(scope.row)"
                      type="text"
                  >
                    查看
                  </el-button>
                  <el-button
                      @click.native.prevent="del(scope.row)"
                      type="text"
                  >
                    删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>

          </div>
        </div>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page_no"
            :page-sizes="[10, 20, 30, 50]"
            :page-size="page_size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
        </el-pagination>

        <div class="conf-btn flex">
          <!-- 可跳过需要验证 -->
          <template v-if="detail.is_skip==1&&detail.is_verify==1">
            <div class="btn" @click="next('skip')">跳过</div>
            <div class="btn next_btn" @click="next('next')">下一步</div>
          </template>
          <!-- 可跳过无需验证 -->
          <template v-if="detail.is_skip==1&&detail.is_verify==0">
            <div class="btn next_btn" @click="next('known')">{{stepMenuList.length-1==active?'已完成': '已知悉' }}</div>
          </template>
          <!-- 不可跳过需要验证 -->
          <template v-if="detail.is_skip==0&&detail.is_verify==1">
            <div class="btn next_btn" @click="next('next')">下一步</div>
          </template>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
import {
  contactsLists,
  delContacts, getmyMenu, Message_delete, Message_detail, Message_lists, skipOrReadStep
} from "@/api/api";
import top from "../components/top.vue"; //头部
import navMenu from "../components/navMenu.vue"; //左侧步骤条
import Index from "./index.vue";

export default {
  components: {top, navMenu},
  name: "attestation",
  data() {
    return {
      stepMenuList:[],
      type: JSON.parse(localStorage.getItem("userdata")).type,
      detail: {},
      formInline: {
        message_title:'',
      },
      loading: false,
      active: 3,
      content: {
        title_brief: "",
      },
      richHtml: "",
      total: 1,
      maxNumber: "",
      page_no: 1,
      page_size: 10,
      tableData: [],
      mark: ''
    };
  },
  mounted() {
    let stepMenuList = JSON.parse(localStorage.getItem("menu"));
    this.stepMenuList = stepMenuList;
    var index = stepMenuList.findIndex(function (item) {
      return item.link_url == "/eventNotification";
    });
    //
    this.active = index;
    this.id = this.$route.query.id;
    this.mark = this.$route.query.mark;
    this.getMenu()
    this.getList();
  },
  methods: {
    getMenu() {
      let that = this;
      let data = this.$qs.stringify({type:this.type});
      getmyMenu(data).then((res) => {

        if (res.code == 1) {
          let {data} = res;
          this.stepMenuList = data;
          let stepMenuList = data;
          var index = stepMenuList.findIndex(function (item) {
            return item.link_url == "/eventNotification";
          });

          that.detail = stepMenuList[index]
          if (stepMenuList[index].children && stepMenuList[index].children.length > 0) {
            that.list = stepMenuList[index].children;
          }

          // that.list[2].link_url="InvoiceManage"
          that.active = index;
        }
      }).catch((err) => {
        console.log(err);
      });
    },
    //    缴费说明
    payDescription() {
      this.dialogVisible = true;
    },
    //   付款信息
    toPayment() {
      this.$router.push({
        name: 'paymentInfoList'
      })
    },
    onSubmit() {
      console.log('submit!');
    },
    // 返回
    goBack() {
      this.$router.back();
    },
    changeContact(type, contacts_long_id) {
      this.$router.push({
        path: '/contactPerson',
        query: {
          type,
          contacts_long_id,
          mark: this.mark
        }
      })
    },
    getList() {
      this.loading=true
      let that = this;
      let data = that.$qs.stringify({
        message_title:this.formInline.message_title,
        type: this.type,
        page_no: this.page_no,
        page_size: this.page_size,
      });
      Message_lists(data).then((res) => {
        this.loading=false
        if (res.code == 1) {
          that.tableData = res.data.lists;
          that.total = Number(res.data.count);
          that.page_no = Number(res.data.page_no);
          that.page_size = Number(res.data.page_size);

        }
      })
          .catch((err) => {
            this.loading=false
            console.log(err);
          });
    },
    //重置
    reset() {
      this.formInline.message_title='';
      this.total = 1;
      this.page_no = 1;
      this.page_size = 10;
      this.getList()

    },
    // 跳转下一步
    next(type) {
      if (type == "next") {
        //下一步
        if (this.detail.action == 1 || this.detail.action == 4) {
          this.toPath();
        } else {
          this.$message.warning("请完善信息!");
        }
      } else if (type == "skip") {
        //跳过
        this.skipOrReadStep(1);
      } else if (type == "known") {
        //已知悉
        this.skipOrReadStep(2);
      }
    },
    // 跳过或者已知悉
    skipOrReadStep(action) {
      let data = {
        type: JSON.parse(localStorage.getItem("userdata")).type,
        action,
        mark: this.detail.mark,
      };
      skipOrReadStep(data)
          .then((res) => {
            if (res.code == 1) {
              this.$message.success("操作成功");
              this.toPath();
            } else {
              this.$message.error(res.data.msg);
            }
          })
          .catch((err) => {
            console.log(err);
          });
    },
    toPath() {
      this.active = this.active + 1;
      let { link_url, menu_title, id } = this.stepMenuList[this.active];
      // if (link_url == "/exhibitorManual" || link_url == "/standPrepare") {
      //   this.$router.push({
      //     path: link_url
      //   });
      // } else {
      this.$router.push({
        path: link_url,
      });
      // }
    },
    // 分页相关
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.page_no = val;
      this.getList();
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    // 详情
    seeDetail(row){
      let data = this.$qs.stringify({
        type: this.type,
        message_long_id: row.message_long_id,
      });
      Message_detail(data).then((res) => {
        if (res.code == 1) {
          this.tableData = res.data;
          this.$router.push({
            path: '/MessageDetail',
            query: {
              contacts:JSON.stringify(res.data)
            }
          })
        }
      })
          .catch((err) => {
            console.log(err);
          });
    },




    del(row) {
      this.$confirm("确定要删除此条品牌数据吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
          .then(() => {
            let data = {
              type: this.type,
              message_long_id: row.message_long_id
            }
            Message_delete(data).then((res) => {
              if (res.code == 1) {
                this.$message.success(res.msg);
                this.getList()
              }
            }).catch((err) => {
              console.log(err);
            });
          })
    },
  },
};
</script>
<style lang="scss" scoped>
.dialogTitle {
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.88);
}

.jfContent {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.88);
  line-height: 22px;
  margin-top: 8px;
}

.dialogLine {
  width: 100%;
  height: 1px;
  background: #EEEEEE;
  margin: 10px 0;
}

/deep/ .el-dialog {
  width: 480px !important;
  height: 340px !important;
  background: #FFFFFF;
  box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05), 0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12);
  border-radius: 8px;
}

/deep/ .el-dialog__body {
  padding: 20px 24px;
  box-sizing: border-box;
}

/deep/ .el-dialog__footer {
  text-align: center;
}

/deep/ .el-dialog__header {
  display: none;
}

.explanatoryText {
  display: inline-block;
  position: relative;
}

.explanatoryText:hover .explanatoryBox {
  display: block;
}

.explanatoryBox {
  display: none;
  width: 340px;
  padding: 20px;
  box-sizing: border-box;
  background: #FFFFFF;
  box-shadow: 0px 3px 8px 1px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  position: absolute;
  z-index: 9999;
  top: 23px;
  left: 0;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 13px;
  color: #333333;

  .mobile {
    margin: 10px 0 8px;
  }
}

.paginationbox {
  width: 100%;
  //position: absolute;
  bottom: 30px;
  left: 0;
}

.searchIcon {
  width: 17px;
  height: 17px;
  vertical-align: middle;
  margin-left: 7px;
  cursor: pointer;
}

.searchTxt {
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 14px;
  color: #000000;
}

.searchBtnBox {
  margin-top: 10px;
}

.btnBox {
  margin: 20px 0;
}

.status {
  display: inline-block;
  width: 56px;
  height: 24px;
  border-radius: 6px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 13px;
  color: #FFFFFF;
  text-align: center;
  line-height: 24px;
}

.sicon1 {
  background: #0091FF;
}

.sicon2 {
  background: #FF4D4F;
}

/deep/ .el-button {
  position: initial;
}

.photo {
  width: 66px;
  height: 66px;
}

.btn_box {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: 30px;
}

.my-table tbody tr td .check-btn.check-del {
  color: #ff4d4f;
  margin-left: 0 !important;
}
</style>
<style lang="scss" scoped>
.conf-btn {
  margin: 30px;
  justify-content: center;
  display: flex;
  //position: absolute;
  //bottom: 30px;
  //left: 50%;
  //transform: translateX(-50%);
  .btn {
    min-width: 128px;
    height: 36px;
    cursor: pointer;
    margin: 0 10px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #333333;
    line-height: 36px;
    text-align: center;
    background: #ffffff;
    border: 1px solid #CAD2DD;
    border-radius: 9px;

    &:hover {
      text-decoration: underline;
    }
  }

  .next_btn {
    color: #fff;
    background: linear-gradient(90deg, #F27FC0 0%, #E40080 100%);
    border: none;
  }
}

.search {
  bottom: initial !important;
  left: 104px !important;
}

.zs_list {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  margin-top: 35px;
}

.zs_item {
  width: -webkit-calc((100% - 25px * 3) / 3);
  width: calc((100% - 25px * 3) / 3);
  margin: 0 25px 25px 0;
  background: #fff;
  border-radius: 6px;

}

.s_box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  box-sizing: border-box;

  .s_f_box {
    display: flex;
    align-items: center;
  }

  .del_icon {
    width: 30px;
    height: 30px;
    background: #fa6400;
    border-radius: 50%;
  }

  .avatar {
    width: 60px;
    height: 60px;
    background: #959ec4;
    margin-right: 10px;
  }

  .info_box {
    font-size: 14px;

    .info_name {
      margin-bottom: 10px;
    }
  }
}

.first_box {
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #eee;

  .status {
    padding: 10px 20px;
    box-sizing: border-box;
    font-size: 12px;
    background: #f7b500;
    border-radius: 6px;
  }

  div {
    display: flex;
    align-items: center;

    img {
      width: 30px;
      height: 30px;
      background: #000;
      border-radius: 50%;
    }

    span {
      display: inline-block;
      margin-left: 10px;
    }
  }

}

.code_txt {
  display: flex;
  flex-direction: column;
  justify-items: center;
  align-items: center;
}

.code_txt div:nth-child(1) {
  margin-bottom: 10px;
}

.code_box {
  width: 100%;
  background: #fff;
  margin: 30px 0;
  display: flex;
  align-items: center;
}

.invitate-wrap {
  // display: flex;
  // margin-top: 10px;
}

// 下载小程序码
.down-code {
  width: 212px;
  // min-height: 212px;
  font-size: 16px;
  color: #48484a;
  line-height: 22px;
  align-items: center;
  padding: 25px;
  box-sizing: border-box;
  margin-right: 20px;
  // background: #f2f6fb;
  border-radius: 9px;

  img {
    max-width: 100%;
    height: auto !important;
  }
}

.invitation-infor {
  align-items: center;
  width: 254px;
  height: 82px;
  padding: 23px;
  font-size: 14px;
  color: #959ec4;
  margin-left: 30px;
  margin-top: 50px;
  border-radius: 18px;
  box-sizing: border-box;
  border: 1px solid #959ec4;
  background: #fafcfe;

  .icon {
    width: 9px;
    height: 9px;
    margin-right: 16px;
    background: #4f6ef7;
    border: 19px solid #e8edfd;
    border-radius: 50%;
  }

  .icon1 {
    background: #fa6400;
    border-color: #f9ece4;
  }

  .icon2 {
    background: #5eb581;
    border-color: #e9f4f1;
  }

  .number {
    flex: 1;
    font-size: 30px;
    font-weight: 500;
    color: #373c52;
    text-align: right;
  }
}

// 已邀请观众列表
.invitation-table {
  // margin-top: 30px;
  // padding-top: 50px;
  // border-top: 10px solid #f2f4f8;
  // min-height: 400px;
  flex: 1;

  .table-title {
    font-size: 20px;
    font-weight: 500;
    color: #2c2c2e;
    line-height: 28px;

    span {
      font-size: 16px;
      color: #636366;
    }
  }
}

.my-table {
  color: #888;
  font-size: 16px;
  margin-top: 10px;
}

.my-table tbody td,
.my-table tbody th {
  height: 70px;
  padding: 5px 0;
  box-sizing: border-box;
}

.my-table tbody th,
.my-table tbody tr {
  background: #f2f6fb;
}

.my-table tbody tr.is-new {
  color: #0e0e0e;
}

.my-table tbody tr td .check-btn {
  color: #1677ff;
  cursor: pointer;
}

.my-table tbody tr td .check-btn:hover {
  text-decoration: underline;
}

.el-table--striped .el-table__body tr.el-table__row--striped td {
  background: #fff;
}

.el-table td,
.el-table th.is-leaf {
  border-bottom: 0 none;
}

/* 表格最外层边框-底部边框 */
.el-table--border::after,
.el-table--group::after {
  width: 0;
}

.my-table::before {
  width: 0;
}

.my-table tbody tr td:first-child {
  border-radius: 10px 0 0 10px;
}

.my-table tbody tr td:last-child {
  border-radius: 0 10px 10px 0;
}

.real {
  width: 85px;
  height: 28px;
  font-weight: 500;
  font-size: 14px;
  color: #0091ff;
  line-height: 28px;
  text-align: center;
  background: rgba(0, 145, 255, 0.15);
  border-radius: 5px;
  display: inline-block;
}

.un-real {
  color: #f7b500;
  background: rgba(247, 181, 0, 0.15);
}

@media only screen and (max-width: 1280px) {
  .zs_item {
    width: 100% !important;
    margin-right: 0 !important;
  }
}

@media only screen and (max-width: 767px) {
  .zs_list {
    width: 90%;
    margin: auto;
  }
  .btn_box {
    flex-wrap: wrap;
  }
  .zs_item {
    width: 100% !important;
    margin: 0 0 25px 0 !important;
  }
  .content .el-button {
    font-size: 15px !important;
  }
  .invitation-table .table-title {
    font-size: 16px !important;

    span {
      font-size: 12px !important;
    }
  }
  .s_box .info_box {
    font-size: 12px !important;
  }
  .s_box .avatar {
    width: 50px !important;
    height: 50px !important;
    margin-right: 4px !important;
  }
  .first_box .status {
    padding: 6px 16px !important;
  }

}
</style>